module.exports = __webpack_public_path__ + "img/newprovidence-MacBook-Pro-mockup-front-page.198506f2.jpg";